import { Component } from '@angular/core';
import { LoaderComponent } from '../../loader/loader.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InventoryService } from '../../../services/inventory.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { SalesService } from '../../../services/sales.service';
import { BillToCustomerLookupComponent } from '../billtocustomer-lookup/billtocustomer-lookup.component';
import { Product } from '../../../model/common/common.model';
import { ShipToCustomerLookupComponent } from '../shiptocustomer-lookup/shiptocustomer-lookup.component';

@Component({
  selector: 'app-create-quick-project',
  standalone: true,
  imports: [LoaderComponent, CommonModule, SharedModule],
  templateUrl: './create-quick-project.component.html',
  styleUrl: './create-quick-project.component.scss'
})
export class CreateQuickProjectComponent {

  constructor(private inventoryService: InventoryService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private salesService: SalesService,
    private projectbomservice: InventoryService,
    public ref: DynamicDialogRef) { }

  loader: boolean = false;
  isEditMode: boolean = false;
  submitted: boolean = false;
  BillTocustomerList: any[] = [];
  products: Product[] = [];
  ShipTocustomerList: any[] = [];
  lineItemDataProjectBom: any[] = [];
  lineItemData: any[] = [];
  projectBoMIdBudget: any;
  projectBudget: any[] = [];
  projectBoMId: any;
  iseditProduct: boolean = false;


  ngonInIt() {
    this.createprojectform.controls['createdBy'].setValue(localStorage.getItem('username'));
    this.manualEntry();
  }


  createprojectform = new FormGroup({
    projectBoMCode: new FormControl('', Validators.required),
    projectBoMName: new FormControl('', Validators.required),
    manualEntry: new FormControl(true),
    BillToCustomerId: new FormControl(),
    ShipToCustomerId: new FormControl(),
    BillToCustomerCode: new FormControl(),
    ShipToCustomerCode: new FormControl(),
    BillToCustomer: new FormControl(),
    ShipToCustomer: new FormControl(),
    createdBy: new FormControl(),
    isActive: new FormControl(true),
    totalReqQuantity: new FormControl(0, Validators.required),
    status: new FormControl('Open'),
    createdDate: new FormControl(new Date())
  });



  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  get isProjectTabValid() {
    return this.createprojectform.get('projectBoMCode')?.valid && this.createprojectform.get('projectBoMName')?.valid;
  }




  checkProductCode() {
    if (!this.iseditProduct) {
      this.inventoryService.checkProductCode(this.createprojectform.controls.projectBoMCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
          } else {
            this.createprojectform.controls.projectBoMCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.createprojectform.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  manualEntry() {
    const manualEntryValue = this.createprojectform.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.createprojectform.controls.projectBoMCode.setValue('');
    } else {
      this.getProductCode();
    }
  }

  getProductCode() {
    this.inventoryService.autogenerateProjectCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'PB';
        // const projectCode = alphanumericCode + data;
        this.createprojectform.controls.projectBoMCode.setValue(data.fullNumber);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  autosearchBilltoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.BillTocustomerList = data.filter((customer: any) => customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  get formControls() {
    return this.createprojectform.controls;
  }

  setBillTo(data: any) {
    if (data.value) {
      this.createprojectform.controls.BillToCustomerCode.setValue(data.value.customerCode);
      this.createprojectform.controls.BillToCustomer.setValue(data.value.customerName);
      this.createprojectform.controls.BillToCustomerId.setValue(data.value.customerId);
    }
  }

  setShipTo(data: any) {
    if (data.value) {
      this.createprojectform.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.createprojectform.controls.ShipToCustomer.setValue(data.value.customerName);
      this.createprojectform.controls.ShipToCustomerId.setValue(data.value.customerId);
    }
  }

  showBillToCustomerDialog() {
    const ref = this.dialogService.open(BillToCustomerLookupComponent, {
      header: 'Bill TO Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createprojectform.patchValue({
          BillToCustomerId: selectedCustomer.customerId,
          BillToCustomerCode: selectedCustomer.customerCode,
          BillToCustomer: selectedCustomer.customerName
        });
      }
    });
  }


  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true && customer.isActive === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createprojectform.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.createprojectform.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.createprojectform.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
      }
    });
  }

  validateForm() {
    let isValid = true;
    if (this.createprojectform.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }


  saveProjectBOM(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (isEditMode) {
    } else {
      this.createProjectBOM(data);
      this.loader = false;
    }
  }



  createProjectBOM(data: any) {
    this.loader = true;
    const projectBoM = {
      projectBoMCode: data.projectBoMCode,
      projectBoMName: data.projectBoMName,
      projectBoMDescription: data.projectBoMDescription,
      status: data.status,
      comment: data.comment,
      customerId: this.createprojectform.controls.BillToCustomerId.value,
      totalReqQuantity: data.totalReqQuantity,
      fgquantity: data.fgquantity,
      billToCustomerId: data.BillToCustomerId,
      shipToCustomerId: data.ShipToCustomerId,
      WBS: data.WBS,
      PONumber: data.PONumber,
      billToCustomerCode: data.BillToCustomerCode,
      shipToCustomerCode: data.ShipToCustomerCode,
      vendorId: data.vendorId,
      vendorCode: data.vendorCode,
      totalWeight: data.totalWeight,
      totalWastage: data.totalWastage,
      requestProjectDate: data.requestProjectDate,
      isActive: data.isActive,
      createdBy: localStorage.getItem('username'),
      updatedBy: data.updatedBy,
      createdDate: data.createdDate,
      updatedDate: data.updatedDate,
      billOfMaterials: data.billOfMaterials || [],
      projectBOM: []
    };

    this.lineItemDataProjectBom = this.lineItemDataProjectBom.map(item => {
      const { finishgoodLineitemNo, ...newItem } = item;
      return newItem;
    });
    if (this.lineItemDataProjectBom && this.lineItemDataProjectBom.length > 0) {
      this.lineItemDataProjectBom.forEach(item => {
        if (item.projectBoMId == null || item.projectBoMId == undefined) {
          item.projectBoMId = 0;
        }
      });
      for (let i = 0; i < this.lineItemDataProjectBom.length; i++) {
        this.lineItemData = this.lineItemDataProjectBom[i].billOfMaterialLineitems;
        this.lineItemDataProjectBom[i].billOfMaterialLineitems = this.lineItemData.map(lineItem => ({ ...lineItem, product: undefined }));
      }
      let billOfMaterials = this.lineItemDataProjectBom.map(item => ({
        ...item,
        IsActive: item.isActive == null ? true : item.isActive,
      }));

    }

    this.projectbomservice.createProject(projectBoM).subscribe(
      (response: any) => {
        if (response.success == true) {
          this.projectBoMIdBudget = response.id;
          this.loader = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });

          this.ref.close({
            projectBoMId: response.id,
            projectBoMCode: projectBoM.projectBoMCode,
            projectBoMName: projectBoM.projectBoMName
          });

          if (this.projectBudget && this.projectBudget.length > 0) {
            const now = new Date();

            const username = localStorage.getItem('username') || '';

            const newBudgets = this.projectBudget.filter(item => !item.projectBudgetId).map(item => ({
              projectBoMId: this.projectBoMIdBudget,
              categoryName: item.categoryName,
              notes: item.notes,
              estimatedCost: item.estimatedCost,
              isActive: true,
              createdBy: username,
              createdDate: now
            }));

          }
        } else {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      (error) => {
        console.error('Error creating project BoM:', error);
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: error.error?.message || 'An unknown error occurred.'
        });
      }

    );
  }

}